// Variants map onto the .btn-* classes in styles/system.css.
const VARIANT_CLASS = {
  default: "btn-default",
  primary: "btn-primary",
  success: "btn-success",
  purple: "btn-primary",
  secondary: "btn-secondary",
  outline: "btn-outline",
  ghost: "btn-ghost",
  danger: "btn-danger",
};
const SIZE_CLASS = { sm: "btn-sm", md: "", lg: "btn-lg", icon: "btn-icon" };

export function Button({
  children,
  className = "",
  variant = "default",
  size = "md",
  type = "button",
  ...props
}) {
  const classes = ["btn", VARIANT_CLASS[variant] || "btn-default", SIZE_CLASS[size] || "", className].filter(Boolean).join(" ");
  return (
    <button type={type} className={classes} {...props}>
      {children}
    </button>
  );
}
